// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  UserStatus,
  userStatusLabelMap,
  userStatusSchema,
} from '@/account/api/types';
import { FilterMenu } from '@/components/filter-menu';

const DEFAULT_LABEL = 'Status';

interface Props {
  /**
   * The currently selected status values
   */
  value: UserStatus[];

  /**
   * A callback fired when the selected status values change
   */
  onChange: (value: UserStatus[]) => void;
}

/**
 * A filter menu component for filtering users by their account status (active/deactivated)
 */
export function UserStatusFilterMenu(props: Props) {
  const options = userStatusSchema.options.map((status) => ({
    id: status,
    label: userStatusLabelMap[status],
    isActive: props.value.includes(status),
  }));

  const handleChangeOption = (id: UserStatus, isActive: boolean) => {
    if (isActive) {
      return props.onChange([...props.value, id]);
    }

    props.onChange(props.value.filter((status) => status !== id));
  };

  return (
    <FilterMenu
      label={DEFAULT_LABEL}
      options={options}
      onChangeOption={handleChangeOption}
    />
  );
}
